<template>
  <el-row class="menu-bar">
    <el-col :span="24">
      <el-menu 
       class="el-menu-vertical-demo"
       @open="handleOpen"
       @close="handleClose" 
     
       :default-active="menuIndex"
       :router="true">
        <el-menu-item
         v-for="item in menus" 
         :key="item.id" 
         :index="item.routeName"
         :route="{ name: item.routeName }"
           @click="removeSearchHistory"
         >
          <i :class="[item.icon]"></i>
          <span slot="title">{{item.translate}}</span>
        </el-menu-item>
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>
import * as types from "@/store/types";
import axios from "axios";
import {mapGetters} from 'vuex';
import _ from "lodash";
import searchHistoryService from "../../services/searchHistoryService";
export default {
  data() {
    return {
      isCollapse: true
    };
  },
  methods: {
    handleOpen(key, keyPath) {
    },
    handleClose(key, keyPath) {
    },
    removeSearchHistory()
    {
       searchHistoryService.removeAll();

    }
  },
  computed: {
    ...mapGetters(['menus','menuIndex'])
  },
  created() {
  }
};
</script>

<style scope>

</style>


// WEBPACK FOOTER //
// src/components/sidebar/Sidebar.vue